<div class="itm-mobile-footer">
    <!-- <ejs-toolbar class="itm-tbar shadow bg-card list-toolbar" [overflowMode]="'Popup'"
        (clicked)="toolbarClick($event)">
        <e-items>
            @for (item of navigation(); track $index) {
                <e-item type="Button" [htmlAttributes]='itmToolbarAction' [id]="item.id" [text]="item.title"></e-item>
            }
        </e-items>
    </ejs-toolbar> -->

    @for (item of navigation(); track trackByFn($index, item)) {
        <!-- Skip the hidden items -->
        @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
            <div
                class="fuse-vertical-navigation-item-wrapper"
                [class.fuse-vertical-navigation-item-has-subtitle]="!!item.subtitle"
                [ngClass]="item.classes?.wrapper">

                @if (item.link && !item.externalLink && !item.function && !item.disabled) {
                    <a class="fuse-vertical-navigation-item"
                        [ngClass]="{
                            'fuse-vertical-navigation-item-active-forced': item.active,
                        }"
                        [routerLink]="[item.link]"
                        [fragment]="item.fragment ?? null"
                        [preserveFragment]="item.preserveFragment ?? false"
                        [queryParams]="item.queryParams ?? null"
                        [queryParamsHandling]="item.queryParamsHandling ?? null"
                        [routerLinkActive]="'fuse-vertical-navigation-item-active'"
                        [routerLinkActiveOptions]="isActiveMatchOptions"
                        [matTooltip]="item.tooltip || ''">
                        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
                    </a>
                }

                <!-- Item with an external link -->
                @if (item.link && item.externalLink && !item.function && !item.disabled) {
                    <a
                        class="fuse-vertical-navigation-item"
                        [href]="item.link"
                        [target]="item.target || '_self'"
                        [matTooltip]="item.tooltip || ''"
                    >
                        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
                    </a>
                }
            </div>
        }
        
        <!-- Item template -->
        <ng-template #itemTemplate>
            <!-- Icon -->
            @if (item.icon) {
                <mat-icon
                    class="fuse-vertical-navigation-item-icon text-[#FFF]"
                    [ngClass]="item.classes?.icon"
                    [svgIcon]="item.icon"
                ></mat-icon>
            }

            <!-- Title & Subtitle -->
            <div class="fuse-vertical-navigation-item-title-wrapper">
                <div class="fuse-vertical-navigation-item-title">
                    <span [ngClass]="item.classes?.title">
                        {{ item.title }}
                    </span>
                </div>
                @if (item.subtitle) {
                    <div class="fuse-vertical-navigation-item-subtitle">
                        <span [ngClass]="item.classes?.subtitle">
                            {{ item.subtitle }}
                        </span>
                    </div>
                }
            </div>

            <!-- Badge -->
            @if (item.badge) {
                <div class="fuse-vertical-navigation-item-badge">
                    <div
                        class="fuse-vertical-navigation-item-badge-content"
                        [ngClass]="item.badge.classes"
                    >
                        {{ item.badge.title }}
                    </div>
                </div>
            }
        </ng-template>
        
    }

</div>